import React, { useCallback, useEffect, useState } from 'react';
import { FieldComponent } from '../../../types/FieldComponent';
import { BooleanFilter } from '../filters/BooleanFilter';
import Checkbox from '@mui/material/Checkbox';
import { debounce } from 'lodash';

export const SPBooleanField: FieldComponent<boolean> = ({
  onChange,
  defaultValue,
  forcedValue,
  disabled,
  isMissing,
  schema,
}) => {
  const [currentState, setCurrentState] = useState<any>({
    value: false,
    send: false,
  });

  const debouncedChange = useCallback(
    debounce((newValue) => {
      onChange(newValue);
    }, 500),
    []
  );

  useEffect(() => {
    if (defaultValue) {
      setCurrentState({
        value: defaultValue === 1,
        send: false,
      });
    }
  }, [defaultValue]);

  useEffect(() => {
    if (currentState.send) {
      debouncedChange(currentState.value);
    }
  }, [currentState, debouncedChange]);

  const handleChange = (value: any) => {
    setCurrentState({
      value: value,
      send: true,
    });
  };

  return (
    <Checkbox
      defaultChecked={defaultValue}
      onChange={(event, checked) => {
        handleChange(checked);
      }}
    />
  );
};

SPBooleanField.includes = (query = undefined, value = undefined) => {
  if (query === undefined || value === undefined || value === null) return true;
  const valueString = value.toString();
  //console.log(query,valueString);
  return query.some((queryPart: string) => {
    valueString.includes(queryPart);
  });
};

SPBooleanField.comparator = (one = false, other = false) => {
  if (one === other) return 0;
  if (one && !other) return -1;
  return 1;
};

SPBooleanField.FilterRenderer = BooleanFilter;
